import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'
import {useCurrentUser} from "@/hooks/useCurrentUser";
import {useUser} from "@clerk/shared/react";

export const usePosthogIdentify = (): void => {
  const posthog = usePostHog()
  const { data: user } = useCurrentUser()
  const { user: clerkUser, isLoaded, isSignedIn } = useUser()

  useEffect(() => {
    // Wait for Clerk to settle: until then `isSignedIn` is undefined and we
    // cannot tell "signed out" apart from "still loading".
    if (!posthog || !isLoaded) {
      return
    }
    if (user && clerkUser) {
      posthog.identify(user.id.toString())
      return
    }

    // Signed out: drop the stored identity so the next person on this device
    // starts a fresh anonymous profile. Guarded on `_isIdentified` because a
    // signed-in user whose profile request is still in flight also lands here,
    // and resetting them would churn the anonymous id on every load.
    if (!isSignedIn && posthog._isIdentified()) {
      posthog.reset()
    }
  }, [user, clerkUser, isLoaded, isSignedIn, posthog])
}
